import { render, staticRenderFns } from "./TeacherModal.vue?vue&type=template&id=40d06e26&scoped=true"
import script from "./TeacherModal.vue?vue&type=script&lang=js"
export * from "./TeacherModal.vue?vue&type=script&lang=js"
import style0 from "./TeacherModal.vue?vue&type=style&index=0&id=40d06e26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d06e26",
  null
  
)

export default component.exports